import { render, staticRenderFns } from "./courses.vue?vue&type=template&id=58e5c0f0&"
import script from "./courses.vue?vue&type=script&lang=ts&"
export * from "./courses.vue?vue&type=script&lang=ts&"
import style0 from "./courses.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports